import utils from '@/utils/index.js';
import axios from 'axios';
const LOGGERURL = ' https://api2.infohubnews.app/v1/tracker';


window.INFOHUBTACKER = function(p = {}, callback) {
    try {
        p.user_id = utils.getCookie('news_flow_uid');
        p.channel = 'inop';
        p.category = 'none';
        p.Country =  utils.loadCountries();
        let data;
        axios({
            url: LOGGERURL,
            params: p
        });
    } catch(e) {
        console.log(e);
    }
};


// WEBPACK FOOTER //
// ./src/utils/tracker.js